const initVideoBlocks = () => {
  const containers = document.querySelectorAll("[data-video-container]");

  for (const container of containers) {
    const thumbnail = container.querySelector("[data-video-thumbnail]");
    const playButton = container.querySelector("[data-video-play-button]");
    const video = container.querySelector("[data-video-element]");

    if (!video) continue;

    const play = () => {
      video.play();
      if (thumbnail) {
        thumbnail.classList.add("is-hidden");
      }
    };

    if (playButton) {
      playButton.addEventListener("click", play);
    }

    if (thumbnail) {
      thumbnail.addEventListener("click", play);
    }

    video.addEventListener("play", () => {
      if (thumbnail) {
        thumbnail.classList.add("is-hidden");
      }
    });
  }
};

if (document.readyState === "loading") {
  document.addEventListener("DOMContentLoaded", initVideoBlocks);
} else {
  initVideoBlocks();
}
